import CMText from '@src/components/Atoms/CMText';
import keywordAtom from '@src/recoils/atom/keyword';
import { useCallback, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { AiFillCheckCircle, AiOutlineEdit } from 'react-icons/ai';
import { CiSearch } from 'react-icons/ci';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import styled from 'styled-components';
import { modalAtom } from '@src/recoils/atom/modal';
import { auth } from '@src/services/api';
import { authKeys } from '@src/keys/authKey';
import { useQuery } from '@tanstack/react-query';
import { useBodyScrollLock } from '@src/hooks/useBodyScrollLock';
import * as gtag from '@src/utils/gtag';
import useAuth from '@src/hooks/useAuth';
import profileAtom from '@src/recoils/atom/profile';
import EditSvg from '@src/assets/imgs/edit.svg';
import SearchSvg from '@src/assets/imgs/search.svg';

type Props = {
  isListPage: boolean;
  postCommunity?: any;
  isActive?: any;
};

const Top = ({ isListPage, postCommunity, isActive }: Props) => {
  const [isCheckBuyRule, setIsCheckBuyRule] = useState(false);
  const [isCheckShareRule, setIsCheckShareRule] = useState(false);
  const { lockScroll } = useBodyScrollLock();
  const setModal = useSetRecoilState(modalAtom);
  const setKeyword = useSetRecoilState(keywordAtom);
  const onCheckBuyRule = useCallback((v: boolean) => {
    setIsCheckBuyRule(v);
  }, []);
  const onCheckShareRule = useCallback((v: boolean) => {
    setIsCheckShareRule(v);
  }, []);
  const onSearch = useCallback((value: string) => {
    setKeyword(value);
  }, []);
  const keywordRef = useRef<any>({});
  const router = useRouter();
  const profile = useRecoilValue(profileAtom);
  const { query } = router;
  const type = query.type;

  const onEdit = () => {
    gtag.communityInsert();
    if (profile.status === '') {
      lockScroll();
      setModal({
        id: 'unAuthorized',
        visible: true,
      });
      return;
    } else {
      lockScroll();
      setModal({
        id: 'selectCommunity',
        visible: true,
      });
    }
  };
  return (
    <>
      {/* 리스트에서 보여지는경우 */}
      {isListPage && (
        <>
          <Container>
            {(router.pathname.startsWith('/community/board') ||
              router.pathname.startsWith('/community/donation')) &&
              !router.pathname.includes('detail') && (
                <SearchContainer>
                  <SearchInput
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        onSearch(keywordRef.current.keyword.value);
                      }
                    }}
                    placeholder="찾고 싶은 이야기를 검색해주세요!"
                    ref={(el) => (keywordRef.current.keyword = el)}
                  />
                  <SearchIcon
                    onClick={() => {
                      onSearch(keywordRef.current.keyword.value);
                    }}
                  />
                </SearchContainer>
              )}
            {router.pathname.includes('donation') && (
              <EditPageButton
                onClick={() => {
                  router.push('/community/edit?type=donation');
                }}
              >
                <TextLeft>도움이 필요하신가요?</TextLeft>
                <ButtonText>
                  <FlexPos>
                    헌혈 요청하기
                    <EditIcon />
                  </FlexPos>
                </ButtonText>
              </EditPageButton>
            )}
            {router.pathname.includes('board') && (
              <EditPageButton onClick={onEdit}>
                <TextLeft>나누고 싶은 이야기가 있다면? </TextLeft>
                <ButtonText>
                  <FlexPos>
                    글쓰기
                    <EditIcon />
                  </FlexPos>
                </ButtonText>
              </EditPageButton>
            )}
            {router.pathname.includes('blood-home') && (
              <>
                <SearchContainer>
                  <SearchInput
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        onSearch(keywordRef.current.keyword.value);
                      }
                    }}
                    placeholder="헌혈의 집을 검색해보세요"
                    ref={(el) => (keywordRef.current.keyword = el)}
                  />
                  <SearchIcon
                    onClick={() => {
                      onSearch(keywordRef.current.keyword.value);
                    }}
                  />
                </SearchContainer>
                <EditPageButton
                  onClick={() => {
                    router.push(
                      '/community/edit?type=board&category=BLOOD_HOME_REVIEW'
                    );
                  }}
                >
                  <TextLeft>다녀온 헌혈장소가 있나요?</TextLeft>
                  <ButtonText>
                    <FlexPos>
                      리뷰 쓰기
                      <EditIcon />
                    </FlexPos>
                  </ButtonText>
                </EditPageButton>
              </>
            )}
          </Container>
        </>
      )}
      {/* 작성에서 보여지는경우 */}
      {!isListPage && (
        <>
          {type === 'donation' && (
            <DonationComfirmContainer>
              <DonationComfirmWrap>
                <DonationRule>사연 작성 전 꼭 지켜주세요!</DonationRule>
                <DonationSubRule>
                  따뜻한 피플문화를 만들기 위해 꼭 지켜주세요.
                </DonationSubRule>
                <FlexMargin>
                  <CheckIcon
                    isCheck={isCheckBuyRule}
                    onClick={() => {
                      onCheckBuyRule(!isCheckBuyRule);
                    }}
                  />{' '}
                  <span>매혈의 목적을 띄는 글은 삼가해주세요.</span>
                </FlexMargin>
                <FlexMargin>
                  <CheckIcon
                    isCheck={isCheckShareRule}
                    onClick={() => {
                      onCheckShareRule(!isCheckShareRule);
                    }}
                  />{' '}
                  <span>연락처를 공유하는 행위는 삼가해주세요.</span>
                </FlexMargin>
              </DonationComfirmWrap>
            </DonationComfirmContainer>
          )}
          <EditButton
            onClick={() => {
              if (
                type === 'donation' &&
                (!isCheckBuyRule || !isCheckShareRule)
              ) {
                return;
              } else {
                postCommunity();
              }
            }}
            isActive={
              type === 'board'
                ? isActive
                : isActive && isCheckBuyRule && isCheckShareRule
            }
            notMargin={type === 'board' ? true : false}
          >
            {query.id ? '수정' : '등록'}
          </EditButton>
        </>
      )}
    </>
  );
};

const Container = styled.div``;

const SearchContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.commonColor.gray002};
  position: relative;
  border-radius: 10px;
  background: ${({ theme }) => theme.commonColor.white};
  margin-bottom: 12px;
  /* padding: 16px 20px; */
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const TextLeft = styled.div`
  text-align: left;
  color: ${({ theme }) => theme.commonColor.white};
  font-family: 'Regular';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px; /* 136.364% */
  letter-spacing: -0.6px;
`;

const FlexPos = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: var(--White, #fff);
  /* web/heading/h3 */
  font-family: 'Regular';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: -0.6px;
`;

const FlexMargin = styled.div`
  display: flex;
  align-items: center;
  margin-top: 4px;
  width: 100%;
  > span {
    margin-left: 8px;
    font-family: 'Regular';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: -0.6px;
  }
`;

const SearchInput = styled.input`
  width: 100%;
  color: ${({ theme }) => theme.commonColor.gray005};
  padding: 18px 20px;
  font-family: 'Regular';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px; /* 177.778% */
  letter-spacing: -0.6px;
`;

const EditPageButton = styled.button`
  padding: 8px 12px;
  width: 100%;
  border-radius: 10px;
  padding: 20px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.commonColor.pink004};
  color: ${({ theme }) => theme.commonColor.white};
`;

const EditButton = styled.button<{ isActive?: boolean; notMargin?: boolean }>`
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.commonColor.pink004 : theme.commonColor.gray004};
  color: ${({ theme, isActive }) =>
    isActive ? theme.commonColor.white : theme.commonColor.white};
  padding: 8px 12px;
  width: 100%;
  border-radius: 10px;
  padding: 20px;
  font-weight: 700;
  font-size: 14px;
  cursor: ${({ isActive }) => (isActive ? 'pointer' : 'none')};
  pointer-events: ${({ isActive }) => (isActive ? 'all' : 'none')};
  margin-top: ${({ notMargin }) => (notMargin ? 0 : '12px')};
`;

const ButtonText = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const EditIcon = styled(EditSvg)`
  & > path {
    fill: ${({ theme }) => theme.commonColor.white};
  }
`;

const SearchIcon = styled(SearchSvg)`
  & > path {
    fill: ${({ theme }) => theme.commonColor.white};
  }
  width: 30px;
  height: 30px;
  margin-right: 20px;
  cursor: pointer;
`;

const DonationComfirmContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.commonColor.gray002};
  border-radius: 10px;
  background: ${({ theme }) => theme.commonColor.white};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const DonationComfirmWrap = styled.div`
  padding: 24px;
`;

const DonationRule = styled(CMText)`
  color: ${({ theme }) => theme.commonColor.black};
  /* web/heading/h3 */
  font-family: 'Regular';
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px; /* 136.364% */
  letter-spacing: -0.6px;
`;

const DonationSubRule = styled.div`
  color: ${({ theme }) => theme.commonColor.gray005};
  margin: 8px 0px;
  font-family: 'Regular';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.6px;
`;

const CheckIcon = styled(({ isCheck, ...props }) => (
  <AiFillCheckCircle {...props} />
))<{ isCheck?: boolean }>`
  width: 20px;
  height: 20px;
  & > path {
    fill: ${({ theme, isCheck }) =>
      isCheck ? theme.commonColor.pink004 : theme.commonColor.gray004};
  }
  cursor: pointer;
`;

export default Top;
